<template>
  <div class="solution">
    <div class="banner">
      <div class="title">私域内容营销</div>
      <div class="desc">
        <section>为企业搭建内容中台，实现私域场景下内容的高效生产、管理协作、极速分发及数据回流</section>
      </div>
      <router-link target="_blank"  to='/contact'><div class="button">立即体验<i class="el-icon-right"></i></div></router-link>
    </div>
    <div class="context">
      <div class="row">
        <div class="introduce right">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>内容生产门槛高且需求量大，专业人员不足，无法及时响应私域内容需求</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">AIGC工具箱：</span>10余款AIGC工具，高效满足文案/平面/H5/PPT/视频/图文等智能编辑</section>
            <section>和批量创作，赋予企业全员内容生产能力</section>
            <section><span>创意热店：</span>8大创意服务类型以及150+创意服务形式，为品牌提供多元优质的内容创意</section>
            <section>供给</section>
          </div>
        </div>
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/private/1.png">
      </div>
      <div class="row drak">
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/private/2.png">
        <div class="introduce left">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>1.私域内容千人千面，传统设计方式机械重复，工作量巨大，分发效率极其低下且容易</section>
            <section>出现品牌合规问题</section>
            <section class="marginTop16">2.缺乏内容管理功能，素材杂乱存储，容易丢失</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">智能内容分发：</span>通过爱设计 AIGC内容中台的内容分发协作能力，快速分发至各部门、</section>
            <section>渠道、门店、员工，全员根据自身需求修改本地化、个性化的内容，并一键分发至私域</section>
            <section>场景</section>
           <section><span>内容管理中心：</span>打破内容孤岛，团队共享集中管理，全格式内容分类标签存储，智能检</section>
            <section>测品牌合规性，高效做到品牌资产统一管理</section>
          </div>
        </div>
      </div>
       <div class="row">
         <div class="introduce right">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>私域内容分发效果无法追溯，营销链路出现断层</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">可视化数据看板：</span>内容中心超过 100+的数据分析指标，让企业的内容营销数据效果一</section>
            <section>目了然</section>
           <section><span>数据监测回流：</span>端到端的数据监测能力，为企业提供实时的营销数据反馈，反哺内容的</section>
            <section>迭代优化，形成营销闭环</section>
          </div>
        </div>
        <img class="img"  :src="`https://respool.isheji.com/isheji/static/qiye/image/home/path_card_9.png`">
      </div>
    </div>
     <banner></banner>
  </div>
</template>
<script>
import banner from '@/components/solutionBanner.vue'
export default {
  name: 'supply',
  components: {
    banner,
  },
}
</script>
<style lang="scss" scoped>
.solution{
    width: 100%;
    min-width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .banner{
      text-align: center;
      background-image: url('https://respool.isheji.com/isheji/static/qiye/image/solution/private/banner.png');
      width: 100%;
      min-width: 1400px;
      height: 460px;
      background-size: cover;
      background-position-x: center;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 60px;
      .title{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
      }
      .desc{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        margin-bottom: 54px;
      }

    }
    .context{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 1400px;
      .drak{
        background: #F7F7F9;
      }
      .row{
          padding-top: 120px;
          align-items: center;
        display: flex;
        justify-content: center;
        width: 100%;
        padding-bottom: 115px;
        .left{
          margin-left: 142px;
        }
        .right{
          margin-right: 142px;
        }
        .introduce{
          .iheader{
            display: flex;
            align-items: center;
            img{
              width: 60px;
              height: 60px;
              border-radius: 8px;
            }
            .iTitle{
              margin-left: 18px;
              display: flex;
              flex-direction: column;
              justify-content: center;

              .bold{
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 33px;
              }
              .thin{
               font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 22px;
              }
            }
          }
          .idesc{
            margin-top: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6C76;
            line-height: 24px;
            margin-bottom: 32px;
            .marginTop16{
              margin-top: 16px;
            }
            .marginTop{
              margin-top: 0;
            }
            span{
              display: inline-block;
              color: #3B3946;
              font-weight: 600;
              margin-top: 16px;
            }
            .title{
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 28px;
                margin-bottom: 16px;
                margin-top: 32px;
                position: relative;
                &::before{
                  content: '';
                  width: 30px;
                  height: 30px;
                  background: linear-gradient(270deg, rgba(255, 167, 126, 0) 0%, #FF6E48 100%);
                  border-radius: 17px;
                  position: absolute;
                  bottom: 0;
                  left: -16px;
                }
            }
            .purple{
              &::before{
                  content: '';
                  width: 30px;
                  height: 30px;
                  background: linear-gradient(270deg, rgba(90, 45, 245, 0) 0%, #5A2DF5 100%);
                  border-radius: 17px;
                  position: absolute;
                  bottom: 0;
                  left: -16px;
                }
            }
          }
        }
        .img{
          width: 595px;
        }

      }
    }

     .button{
        width: 126px;
        height: 44px;
        background: #5A2DF5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
          .el-icon-right{
            display: none;
            margin-left: 8px;
          }
        &:hover{
          .el-icon-right{
            display: block;
            margin-left: 8px;
            color: #FFFFFF;
          }
        }
      }
}
</style>
